








import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class TransitionGroupFade extends Vue {
  @Prop({ type: String, default: 'span' })
  readonly tag!: string;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/transition/Group.vue